import { getFunctions, httpsCallable } from "firebase/functions"
import { getCurrentUser } from "hooks/localstate/auth/useCurrentUser"
import { CreateNewShopRequest, CreateNewShopResponse } from "types/cloud-functions/createNewShop"

export const createNewShop = async (requestData: CreateNewShopRequest) => {
  const currentUser = getCurrentUser()
  if (!currentUser) {
    throw new Error("You need to be signed in to call createNewShop")
  }
  const createNewShopFunction = httpsCallable<CreateNewShopRequest, CreateNewShopResponse>(
    getFunctions(),
    "groupF-createNewShop"
  )
  const result = await createNewShopFunction(requestData)
  return result.data
}
